module.exports = __webpack_public_path__ + "static/img/3.3516397.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/HeavyCopper/3.png
// module id = EqaL
// module chunks = 1